import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractSpecificDataComponent } from '../../abstract-specific-data.component';

@Component({
  selector: 'app-specific-data-conf30',
  standalone: false,
  templateUrl: './specific-data-conf30.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../specific-data-conf.common.scss'],
})
export class SpecificDataConf30Component extends AbstractSpecificDataComponent {
  @Input() override touchNonce?: number;
  override getDataName(): string {
    return 'specific-data-conf30';
  }
}